import { useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { getFile } from './api-requests';
import "./file-viewer.scss"
import DropDownButton from 'devextreme-react/drop-down-button';
import { Oval } from 'react-loader-spinner'
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { saveAs } from 'file-saver';

const FileViewer = ({ files }) => {

    const [stateFiles, setStateFiles] = useState([]);
    const [popupImage, setPopupImage] = useState(null);

    const imageTypes = ['gif', 'jpeg', 'jpg', 'png', 'webp', 'bmp', 'tiff', 'tif', 'ico'];

    const isImage = (name) => {

        let fileInfo = name.split('.');

        if (fileInfo.length && fileInfo.length > 1) {

            let fileExt = fileInfo[fileInfo.length - 1].toLowerCase();

            if (imageTypes.some(a => a == fileExt)) {
                return true;
            }
        }

        return false;
    }

    const [images, setImages] = useState([]);
    const [loadedImages, setLoadedImages] = useState([]);
    const [errorImages, setErrorImages] = useState([]);

    useEffect(() => {
        if (files && files.length) {
            setStateFiles([...files]);
            setImages(files && files.length ? files.map(file => ({ ...file, error: false, src: null, notImage: !isImage(file.name), isLoading: isImage(file.name) })) : []);
        } else {
            setStateFiles([]);
            setImages([]);
        }
    }, [files]);

    const handleImageLoad = (index) => {
        if (!loadedImages.includes(index)) {
            setLoadedImages([...loadedImages, index]);
        }
    };

    const handleImageError = (index) => {
        setErrorImages([...errorImages, index]);
    };

    const base64ArrayBuffer = (arrayBuffer) => {
        var base64 = ''
        var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

        var bytes = new Uint8Array(arrayBuffer)
        var byteLength = bytes.byteLength
        var byteRemainder = byteLength % 3
        var mainLength = byteLength - byteRemainder

        var a, b, c, d
        var chunk

        // Main loop deals with bytes in chunks of 3
        for (var i = 0; i < mainLength; i = i + 3) {
            // Combine the three bytes into a single integer
            chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

            // Use bitmasks to extract 6-bit segments from the triplet
            a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
            b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
            c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
            d = chunk & 63               // 63       = 2^6 - 1

            // Convert the raw binary segments to the appropriate ASCII encoding
            base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
        }

        // Deal with the remaining bytes and padding
        if (byteRemainder == 1) {
            chunk = bytes[mainLength]

            a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

            // Set the 4 least significant bits to zero
            b = (chunk & 3) << 4 // 3   = 2^2 - 1

            base64 += encodings[a] + encodings[b] + '=='
        } else if (byteRemainder == 2) {
            chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

            a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
            b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

            // Set the 2 least significant bits to zero
            c = (chunk & 15) << 2 // 15    = 2^4 - 1

            base64 += encodings[a] + encodings[b] + encodings[c] + '='
        }

        return base64
    }

    //const onChange = useCallback((id, value) => {
    //    setImages(prevItems => prevItems.map((item, index) => {
    //        return index !== id ? item : { value: value }
    //    }))
    //}, [])


    const fetchImages = async () => {

        if (!stateFiles || !stateFiles.length)
            return;

        for (const [index, file] of stateFiles.entries()) {

            if (!isImage(file.name))
                continue;

            try {
                const binaryData = await getFile(file.id);

                if (!binaryData || !binaryData.length) {

                    setImages(prevImages => {
                        const updImages = [...prevImages];
                        updImages[index] = { ...updImages[index], isLoading: false, error: true };
                        return updImages;
                    });
                }

                else {

                    setImages(prevImages => {
                        const updImages = [...prevImages];
                        updImages[index] = { ...updImages[index], src: "data:image/png;base64," + base64ArrayBuffer(binaryData), isLoading: false };
                        return updImages;
                    });
                }
            }
            catch (error) {

                setImages(prevImages => {
                    const updImages = [...prevImages];
                    updImages[index] = { ...updImages[index], isLoading: false, error: true };
                    return updImages;
                });
            }
        }
    };



    useEffect(() => {
        fetchImages();
    }, [stateFiles]);

    const handleImageClick = (image) => {
        setPopupImage(image);
    }

    const handleDropDownItemClick = async (index, itemData) => {
        if (itemData == "Завантажити файл") {

            const binaryData = await getFile(images[index].id);

            var uint8Array = new Uint8Array(binaryData.length);
            for (var i = 0; i < uint8Array.length; i++) {
                uint8Array[i] = binaryData[i];
            }

            saveAs(new Blob([uint8Array], { type: 'application/octet-stream' }), images[index].name);

        } else {

            setPopupImage(images[index]);
        }
    }



    if (!stateFiles || !stateFiles.length || !images || !images.length)
        return <></>


    return (

        <div>
            <div className="picture-viewer">


                {
                    images.map((image, index) => {

                        /* console.log(index);*/

                        return (

                            <div key={index}>
                                <div className={image.src ? "imageContainer" : "emptyImageContainer"} style={{ display: image.notImage ? "none" : "flex" }}>
                                    <i style={{ display: !image.isLoading && !image.src ? "block" : "none" }} className="dx-icon-image" title={image.error ? "помилка завантаження" : ""}></i>
                                    <img key={index}
                                        src={image.src}
                                        alt={`Image ${index + 1}`}
                                        style={{ display: image.src ? 'inline' : 'none', cursor: "pointer" }}
                                        onClick={() => handleImageClick(image)}
                                    ></img>

                                    <Oval height={60}
                                        width={60}
                                        color="#dedede"
                                        secondaryColor="#dedede"
                                        ariaLabel='Завантажується зображення'
                                        strokeWidth={2}
                                        strokeWidthSecondary={2}
                                        visible={image.isLoading}

                                    ></Oval>
                                </div>

                                <DropDownButton className={image.notImage ? "fileDropDownButton" : "imageDropDownButton"}
                                    activeStateEnabled={false}
                                    hoverStateEnabled={false}
                                    focusStateEnabled={false}
                                    text={image.name}
                                    items={image.notImage ? ["Завантажити файл"] : ["Завантажити файл", "Подивитись у повний розмір"]}
                                    icon={image.notImage ? "file" : undefined}
                                    onItemClick={(e) => handleDropDownItemClick(index, e.itemData)}
                                >
                                </DropDownButton>
                            </div>
                        )
                    }

                    )}
            </div>

            <Popup

                width={"80%"}
                height={"80%"}
                visible={popupImage != null}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={popupImage ? popupImage.name : ""}
                dragEnabled={false}
                onHiding={() => { setPopupImage(null) }}

            >
                <div className="dxPopupPictureViewContent">
                    <img style={{ display: popupImage ? "block" : "none", maxHeight: "100%" }} src={popupImage ? popupImage.src : ""}>

                    </img>
                </div>

            </Popup>

        </div>
    );
};

export default FileViewer;



